function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { SVG } from '@svgdotjs/svg.js';
import ScrollBooster from 'scrollbooster';
var Metro = /*#__PURE__*/ function() {
    "use strict";
    function Metro() {
        _class_call_check(this, Metro);
        _define_property(this, "data", metroData);
        _define_property(this, "$els", {
            root: document.querySelector('[data-metro-plan]'),
            scroll: document.querySelector('[data-metro-scroll]'),
            title: document.querySelector('[data-metro-title]'),
            time: document.querySelector('[data-metro-time]')
        });
    }
    _create_class(Metro, [
        {
            key: "drawMetro",
            value: function drawMetro() {
                var _this = this;
                var _this_data = this.data, image = _this_data.image, points = _this_data.points;
                this.draw = SVG().addTo(this.$els.root);
                this.draw.image(image, function(e) {
                    var _e_target = e.target, width = _e_target.width, height = _e_target.height;
                    _this.draw.viewbox(0, 0, width, height);
                    _this.$els.root.style.width = "".concat(width / 10, "rem");
                });
                points.forEach(function(point) {
                    var circle = _this.draw.circle(16).fill('rgba(0, 0, 0, 0)');
                    circle.css({
                        cursor: 'pointer'
                    });
                    circle.move(point.coords.x - 8, point.coords.y - 8);
                    circle.on('click', function() {
                        _this.$els.title.innerText = point.title;
                        _this.$els.time.innerText = point.time;
                    });
                });
            }
        },
        {
            key: "init",
            value: function init() {
                if (!this.$els.root) return;
                var sb = new ScrollBooster({
                    viewport: this.$els.scroll,
                    content: this.$els.root,
                    scrollMode: 'transform',
                    emulateScroll: false
                });
                window.addEventListener('modalAfterOpen', function(event) {
                    if (event.detail.id === 'metro') {
                        sb.updateMetrics();
                    }
                });
                this.drawMetro();
            }
        }
    ]);
    return Metro;
}();
export default Metro;
